﻿
function validateNumber($o) {
  var val = $o.val();
  if (val.indexOf(",") >= 0) {
    alert("Please use a point \".\" for decimals.");
    setTimeout(function () { $o.focus(); }, 1);
    return false;
  } else if (val != "" && !isNumber(val)) {
    alert("Please enter a valid number into the field.");
    $o.css('border', '2px solid red').css('color', 'red');
    setTimeout(function () { $o.focus(); }, 1);
    return false;
  }
  if (parseFloat(val, 10) > 0)
    $o.parent().children("div").show("fast"); // div>label>input ---> ../../div
  else
    $o.parent().children("div").hide("fast");
  $o.css('border', '1px solid #ccc').css('color', 'black');
  return true;
}

function validatePercent($o) {
  if (validateNumber($o)) {
    var value = $($o).val();
    if (value >= 0 && value <= 100) {
      return true;
    } else {
      alert("Please enter a valid percentage value into the field.");
      $o.css('border', '2px solid red').css('color', 'red');
      setTimeout(function () { $o.focus(); }, 1);
      return false;
    }
  }
}

function validateImage($o) {
  if ($o == null || $o.val() == null || $o.val() == '') return true;
  var fileExtension = "";
  if ($o.val().lastIndexOf(".") > 0) {
    fileExtension = $o.val().substring($o.val().lastIndexOf(".") + 1, $o.val().length).toLowerCase();
  }
  if (fileExtension == "jpeg" || fileExtension == "jpg" || fileExtension == "png" || fileExtension == "gif" || fileExtension == "bmp") {
    return true;
  }
  else {
    alert("You must select an image file for upload (gif, jpeg, png and bmp are accepted)");
    var control = $o;
    control.replaceWith(control = control.clone(true));
    return false;
  }
}

function validateChoices($o) {
  var exclusive = $o.hasClass("exclusive");
  $("input[name=\"" + $o.attr("name") + "\"][type!=\"hidden\"]").each(function () {
    var $p = $(this);
    if ($p.is(":checked") && ((exclusive && this !== $o[0]) || (!exclusive && $p.hasClass("exclusive"))))
      $p.attr('checked', false);
    if ($p.is(":checked")) {
      if ($.trim($p.parent().parent().children("div").html()) != "") {
        $p.parent().parent().children("div").show("fast"); // div>label>input ---> ../../div
      }
    }
    else {
      if ($.trim($p.parent().parent().children("div").html()) != "") {
        $p.parent().parent().children("div").hide();
      }
    }
  });
  return true;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

//#region  Validation For Registration
$(document).on("click", "input.submitvalidate", function (e) {
  if (validateRequiredControl($('#EmailAddress'), 'Enter Email Address') == false) {
    e.preventDefault();
    return; 
  }
  if ($('#CompanyName').length) {
    if (validateRequiredControl($('#CompanyName'), 'Enter Company Name') == false) {
      e.preventDefault();
      return;
    }
  }
  if ($('#Regions').length) {
    if (validateRequiredControl($('#Regions'), 'Select Region!') == false) {
      e.preventDefault();
      return;
    }
  }
  if ($('#CompanyCode').length) {
    if (validateRequiredControl($('#CompanyCode'), 'Enter Company Code') == false) {
      e.preventDefault();
      return;
    }
  }
  var new_password = $('#NewPassword').val();
  var decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{7,}$/;
  var email = $('#EmailAddress').val();
  var confemail = $('#EmailAddressConfirm').val();
  if (email != confemail) {
    e.preventDefault();
    alert('Email Not Matching!');
    return false;
  }
  if (!new_password.match(decimal)) {
    alert('Password must contain at least one number and one uppercase and lowercase letter and one special character, and at least 7 or more character')
    return false;
  }
  if ($('#ConfirmPassword').length) {
    var confirm_password = $('#ConfirmPassword').val();
    if (new_password != confirm_password) {
      e.preventDefault();
      alert('Password Not Matching!');
    }
  }
});
function validateRequiredControl($o,strMsg) {
  var val = $.trim($o.val());
  if (val == '') {
    alert(strMsg);
    return false;
  }
}
//#endregion

//Need to write test
function ApplyValidateRangeGroups(e) {
  if (typeof e === "undefined") {
    throw new Error();
  }
  if (!ValidateRangeGroups()) {
    alert("Your values do not add upto 100%. Please correct your inputs.");
    e.preventDefault();
    return false;
  }
  return true;
}

//Need to write test
function ValidateRangeGroups() {
  var validated = true;
  if ($("#islive").val() == "yes") {
    $(".rangegroup").each(function () {
      var group = $(this);
      if (CheckMinMax(group)) {
        validated = true;
      } else {
        validated = false;
        $(group).css('border', '2px solid red').css('color', 'red');
        return false;
      }
    });
  }
  return validated;
}
$(".btn-login").click(function () {
        localStorage.setItem('SignIn_Click', 'Sign-in error');
  		var res = ValidateOnSignInClick();
        if(res)
        {
            $(".clearfix").css("display", "");
            return false;
        }
});

function ClearErrorMessage(control) {
    $('#' + control[0].id + 'ErrorMessage').empty();
    return true;
}
function ValidateOnSignInClick() {
    var isValidate = 0;

    if ($("#username").length > 0)
        isValidate += validateEmailOnSignIn($("#username")) ? 0 : 1;
    if ($("input[name='password']").length>0)
        isValidate += validatePasswordOnSignIn($("input[name='password']")) ? 0 : 1;
    if ($("input[name='newpassword']").length > 0)
        isValidate += validatePasswordOnNewPassword($("input[name='newpassword']")) ? 0 : 1;
    return isValidate;
}

function validateEmailOnSignIn(email) {
    if (email.val() == "" || email.val() == undefined)
        return appendErrorMessage(email, "Enter your email address or username.");
    return ClearErrorMessage(email);
}

function validatePasswordOnSignIn(password) {
    if (password.val() == "" || password.val() == undefined)
        return appendErrorMessage(password, "Enter your Password.");
    return ClearErrorMessage(password);
}

function validatePasswordOnNewPassword(password) {
    if (password.val().length > 0 && password.val().trim().length == 0) {
        return appendErrorMessage(password, "The Password can't contain only white spaces.");
    }
    if (password.val() == "" || password.val() == undefined)
        return appendErrorMessage(password, "Enter your Password.");

    return ClearErrorMessage(password);
}

function appendErrorMessage(control, errorMessage) {
    control.after(function () {
        $('#' + control[0].id + 'ErrorMessage').empty();
        return '<p style="color:red;text-align: left;" id="' + control[0].id + 'ErrorMessage' + '">' + errorMessage + '</p>';
    });
    return false;
}

